export default "__VITE_ASSET__86ee3c30__"